import React, { Component } from 'react';
import '../css/style.css';
import './Header.css';
import {  Row, Col } from 'react-bootstrap';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';
import { Redirect } from 'react-router-dom';


class AdminHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.user
        };
    }

    onLogout() {
        AuthenticationService.logout();
        let oldState = this.state;
        this.setState({
            ...oldState,
            user: ''
        })
    }


    render() {
        const { t } = this.props;
        //let lang = i18n.language;
        let user = AuthenticationService.getLoggedUser();
        if(!user){
            return <Redirect to="/loginPage/home" />
        }
        return (
            <div >
                
                {this.props.title ? 
                <Row className="mt-3 mb-2 justify-content-xl-center">
                <Col></Col>
                <Col>
                    <h4>{this.props.title}</h4>
                </Col>
                <Col></Col>
            </Row>:''
                }
                
            </div>
        );
    }

}


export default translate("translations")(AdminHeader);